// src/App.js
import React from 'react';
import BirthdayWebsite from './BirthdayWebsite'; // Import your new component
import './App.css'; // You can keep or remove this if not needed

function App() {
  return (
    <div className="App">
      <BirthdayWebsite />
    </div>
  );
}

export default App;